import { DataDogLog } from 'services/logs/datadog';
import { v4 as uuidv4 } from 'uuid';

class TimeLogger {
  private readonly startTime: number;
  private lastTime: number;
  private readonly sequenceId: string;
  private readonly currentConversationId: string | null;

  constructor(sequenceId?: string) {
    this.currentConversationId = null;

    this.startTime = performance.now();
    this.lastTime = this.startTime;
    this.sequenceId = sequenceId || uuidv4();

    DataDogLog.info(
      `[${this.sequenceId}] Starting overall performance tracking.`,
      {
        ConversationId: this.currentConversationId,
        TraceId: this.sequenceId,
        OperationTimeMs: 0,
      },
    );
  }

  log(operation: string) {
    const now = performance.now();
    const operationDurationMs = now - this.lastTime;
    const operationDuration = operationDurationMs / 1000;
    const overallDuration = (now - this.startTime) / 1000;
    this.lastTime = now;

    DataDogLog.info(
      `[${
        this.sequenceId
      }] Web Operation '${operation}' took ${operationDuration.toFixed(
        2,
      )} seconds and overall ${overallDuration.toFixed(2)}s since start`,
      {
        ConversationId: this.currentConversationId,
        TraceId: this.sequenceId,
        OperationTimeMs: operationDurationMs,
      },
    );
  }

  logEnd(message: string) {
    const now = performance.now();
    const overallDurationMs = now - this.startTime;
    const overallDuration = overallDurationMs / 1000;

    DataDogLog.info(
      `[${this.sequenceId}] ${message} in '${overallDuration.toFixed(
        4,
      )}' seconds`,
      {
        TraceId: this.sequenceId,
        ConversationId: this.currentConversationId,
        OperationTimeMs: overallDurationMs,
      },
    );
  }

  getSequenceId() {
    return this.sequenceId;
  }
}

export default TimeLogger;
